import Loadable from 'components/Loadable';

const discountsVerify = {
  path: '/verify-certificates-subscription-offer',
  component: Loadable({
    loader: () => import('../views/discounts'),
  }),
  routes: [
    {
      exact: true,
      path: '/verify-certificates-subscription-offer',
      component: Loadable({
        loader: () => import('../views/discounts/verify-certificates/landing'),
      }),
    },
  ],
};

const discountsValidate = {
  path: '/validate-certificates-subscription-offer',
  component: Loadable({
    loader: () => import('../views/discounts/validate-certificates'),
  }),
  routes: [
    {
      exact: true,
      path: '/validate-certificates-subscription-offer',
      component: Loadable({
        loader: () =>
          import('../views/discounts/validate-certificates/landing'),
      }),
    },
    {
      path: [
        '/validate-certificates-subscription-offer/verify/:accountId',
        '/validate-certificates-subscription-offer/verified/:accountId',
      ],
      component: Loadable({
        loader: () => import('../views/discounts/validate-certificates/verify'),
      }),
    },
  ],
};

export {discountsVerify, discountsValidate};
